<template>
  <div>
    <banner />
    <chart-view-selection v-on:chart-selection="setSelection"/>
    <div v-if="chartView=='heat-map'">
      <country-chart-view />
    </div>
    <div v-else-if="chartView=='data'">
      <directory-search-bar />
      <bar-chart-view />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import slugify from "slugify";
import Banner from "../elements/LandingPageBanner.vue"
import DirectorySearchBar from "../elements/SearchBars/IndexSearchBar.vue"
import BarChartView from "../elements/BarChartView.vue"
import CountryChartView from "../elements/CountryChartView.vue"
import ChartViewSelection from "../elements/ChartViewSelection.vue"
export default {
  name: "Directory",
  components: {
    banner: Banner,
    'directory-search-bar': DirectorySearchBar,
    'bar-chart-view': BarChartView,
    'country-chart-view': CountryChartView,
    'chart-view-selection': ChartViewSelection
  },
  data() {
    return {
      msg: slugify("Directory page", { lower: true }),
      chartView: 'heat-map'
    };
  },
  computed: {
    ...mapGetters([
      "currentResults",
      "results",
      "capitalTypes",
      "providerTypes",
      "sectors",
      "devCountries",
      "getSelectedCapitalTypes",
      "getSelectedProviderTypes",
      "getSelectedCountries",
      "getSelectedSectors",
      "countrySelected",
      "sectorSelected",
      "capitalTypeSelected",
      "providerTypeSelected",
      "femaleFocusSelected",

      "providerList"
    ])
  },
  methods: {
    ...mapActions({
      fetchProvider: "fetchProvider",
      search: "search"
    }),
    ...mapMutations({
      setCapitalType: "setCapitalTypesParam",
      setProvidersType: "setProviderTypesParam",
      setSector: "setSectorsParam",
      setFemaleFocus: "setFemaleFocusParam"
    }),
    toggleFemaleFocus: function() {
      this.setFemaleFocus(!this.femaleFocusSelected);
    },
    navToProviderProfile: function(provider) {
      if (provider.hasOwnProperty("name")) {
        var urlParam = slugify(provider.name, { lower: true });
        this.$router.push({
          name: "Profile",
          params: { providerName: urlParam }
        });
      }
    },
    setSelection(v){
      this.chartView = v
    }
    // backgroundClass(selection){
    //   if (this.$route.name == selection) return 'background-selected'
    //   return 'background-not-selected'
    // }
  },
  created() {
    // this.navToProviderProfile(this.providerList[10])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue